module.exports = __webpack_public_path__ + "img/hopways.1d70f347.webp";